import EventNoteIcon from "@mui/icons-material/EventNote";
import { CYCLES, GraduationServicePath, SCHEDULES, STREAMS } from "utils/constants";
import permissions from "app/permissions";
import ListScheduleCycleStream from "./List";
import CreateScheduleCycleStream from "./Create";
import ShowScheduleCycleStream from "./Show";
import EditScheduleCycleStream from "./Edit";

export const resources = {
  isMenu: true,
  icon: <EventNoteIcon />,
  name: GraduationServicePath + SCHEDULES + "/" + CYCLES + "/" + STREAMS,
  title: "Разписание - Циклични потоци",
  list: <ListScheduleCycleStream />,
  create: <CreateScheduleCycleStream />,
  edit: <EditScheduleCycleStream />,
  show: <ShowScheduleCycleStream />,
  permission: permissions.canPreviewInternshipSchedules,
};
